import { RadioOption, SelectableOptionCard } from '~/shared/components/SelectableOption';

export interface RadioOptionItem<T extends string = string> {
  value: T;
  label: string;
  description?: string;
  inputClassName?: string;
}

interface RadioOptionListProps<T extends string> {
  name: string;
  options: RadioOptionItem<T>[];
  selected: T;
  onChange: (value: T) => void;
}

export default function RadioOptionList<T extends string>({
  name,
  options,
  selected,
  onChange,
}: RadioOptionListProps<T>) {
  return (
    <>
      {options.map((opt) => (
        <SelectableOptionCard
          key={opt.value}
          inputId={`${name}-${opt.value}`}
          checked={selected === opt.value}
          label={opt.label}
          description={opt.description}
        >
          <RadioOption
            id={`${name}-${opt.value}`}
            name={name}
            value={opt.value}
            checked={selected === opt.value}
            onChange={onChange}
            className={opt.inputClassName}
          />
        </SelectableOptionCard>
      ))}
    </>
  );
}
